import {Form, Input, Select, message, Breadcrumb, Layout, Card, Button} from 'antd';
import {FormattedMessage, useIntl} from "react-intl";
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    setLoading,
    clearLoading,
    addStaff,
    getStaff,
    editStaff,
    clearStaffError
} from "../../redux/staff/staffActions";
import {HomeOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {selectError, selectLoading, selectCurrentStaff} from "../../redux/staff/staffSelector";
import {listProjects} from "../../redux/project/projectActions";
import {selectProjects} from "../../redux/project/projectSelector";

const {Content, Footer} = Layout;


const StaffForm = (props) => {

    const intl = useIntl();
    const dispatch = useDispatch();

    const [staffCreated, setStaffCreated] = useState(false);
    const [edit, setEdit] = useState(props.location.pathname !== '/staff/new');

    const [form] = Form.useForm();

    const onFinish = (values) => {
        if (edit) {
            props.editStaff(props.history, props.match.params.id, values, setStaffCreated);
        } else {
            props.addStaff(props.history, values, setStaffCreated);
        }

    };

    const onFinishFailed = (errorInfo) => {
        errorInfo.errorFields.map(error => (message.error(error.errors[0])));
    };

    const [projectList, setProjectList] = useState([{label: intl.formatMessage({id: 'label.select'}), value: null}])

    useEffect(() => {
        if (projectList.length === 1) {
            dispatch(setLoading());
            if (props.project === null || props.project.length === 0) {
                let pagination = {}
                pagination['current'] = 1;
                pagination['pageSize'] = 9999999;
                let sorter = {}
                sorter['field'] = 'name';
                dispatch(listProjects(props.history, pagination, {}, sorter));
            } else {
                const loadedProjects = [...projectList];
                props.project?.projects?.map(project => loadedProjects.push({label: project.name, value: project.id}))
                setProjectList(loadedProjects);
                dispatch(clearLoading());
            }
        }
        if (props.error) {
            const error = () => {
                if (typeof props.error == "string") {
                    message.error(props.error).then(props.clearStaffError());
                } else if (props.error.hasOwnProperty('message')) {
                    message.error(props.error.message).then(props.clearFormDataError());
                } else {
                    props.error.errors.map(errorMessage =>
                        (message.error(errorMessage.message).then(props.clearStaffError())));
                }

            };
            error();
        }

        if (edit && !staffCreated && props.error === null) {
            props.getStaff(props.history, props.match.params.id).then((data) => {
                if (data) {
                    form.setFieldsValue({
                        'name': data.name,
                        'project': data.project,
                        'email': data.email,
                    });
                } else {
                    setEdit(false);
                }
            })
        }

        if (staffCreated) {
            if (edit) {
                message.info(intl.formatMessage({id: 'label.staff-updated'}));
            } else {
                form.resetFields();
                message.info(intl.formatMessage({id: 'label.staff-created'}));
            }
            setStaffCreated(false);
        }
        // eslint-disable-next-line
    }, [props.error, staffCreated, edit, props.project])

    return (
        <Layout className="site-layout">
            <Content style={{margin: '0 16px'}}>
                <Breadcrumb style={{margin: '10px 0'}}>
                    <Breadcrumb.Item>
                        <HomeOutlined/>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <span><FormattedMessage id="label.staff" defaultMessage="Staff"/></span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <span>{edit ? (<FormattedMessage
                            id="label.edit" defaultMessage="Edit"/>) : (
                            <FormattedMessage id="label.new" defaultMessage="New"/>)}</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="site-layout-background" style={{padding: 24, minHeight: 360}}>
                    <Card type="inner"
                          title={edit ? <FormattedMessage id="label.edit-staff" defaultMessage="Edit Staff"/> :
                              <FormattedMessage id="label.create-staff" defaultMessage="Add Staff Member"/>}
                          extra={<Link to='/staff'><FormattedMessage id="label.return"
                                                                     defaultMessage="Return"/></Link>}>
                        <Form layout="horizontal" name="staff_form" size="large"
                              labelCol={{span: 3,}} wrapperCol={{span: 14,}}
                              initialValues={{active: true}} form={form}
                              onFinish={onFinish} onFinishFailed={onFinishFailed}>
                            <Form.Item name="project" label={intl.formatMessage({id: 'label.project'})}
                                       rules={[{
                                           required: true,
                                           message: intl.formatMessage({id: 'msg.input-required'})
                                       }]}>
                                <Select options={projectList}>

                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="name"
                                label={intl.formatMessage({id: 'label.name'})}
                                rules={[{required: true, message: intl.formatMessage({id: 'msg.input-required'})}]}

                            >
                                <Input/>
                            </Form.Item>
                            <Form.Item
                                name="email"
                                label={intl.formatMessage({id: 'label.email'})}
                                rules={[{required: true, message: intl.formatMessage({id: 'msg.input-required'})}]}

                            >
                                <Input type='email'/>
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={props.loading}>
                                    {edit ? (<FormattedMessage id="label.update" defaultMessage="Update"/>) : (
                                        <FormattedMessage id="label.submit" defaultMessage="Submit"/>)}

                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </div>
            </Content>
            <Footer style={{textAlign: 'center'}}>©{new Date().getFullYear()}</Footer>
        </Layout>
    );
};

const mapStateToProps = state => ({
    loading: selectLoading(state),
    error: selectError(state),
    staff: selectCurrentStaff(state),
    project: selectProjects(state)
});

export default connect(mapStateToProps, {addStaff, getStaff, editStaff, clearStaffError})(StaffForm);